import React, { useContext, useEffect } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useListUsersQuery } from '../../redux/Api/CustomerApiSlice'
import ReusableTable from '../../components/other/ReuseableTable'
import Loader from '../pages/loader'
import { useState } from 'react'
import EditCreateCustomer from '../../components/Customers/EditCreateCustomer'
import { can } from '../../helpers/auth'
import NoPermission from '../pages/noPermission'
import { toast } from 'react-toastify'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import CountriesDropdown from '../../components/CountriesDropdown'

const Customers = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const {
    data: customers,
    isLoading,
    error,
    isFetching
  } = useListUsersQuery({
    expand: ['country', 'last_updated_by'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ordering: 'id',
    search: search || undefined,
    ...filters
  })
  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
    },
    {
      title: 'Customer Business',
      dataIndex: 'customer_business',
      key: 'customer_business',
    },
    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country.country_name',
      filter: true,
      filterComponent: CountriesDropdown,
      render: country => (country ? country.country_name : '')
    },
    {
      title: 'Last Updated By',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: (text, record) => {
        const { last_updated_by } = record
        return last_updated_by
          ? `${last_updated_by.first_name} ${last_updated_by.last_name}`
          : ''
      }
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          <button
            className='btn btn-outline-theme'
            onClick={() => handleEdit(record)}
          >
            Edit
          </button>
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  const context = useContext(AppSettings)
  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return function cleanUp () {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [])

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  if (!can('view_customer')) {
    return <NoPermission />
  }
  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />
      {edit ? (
        <EditCreateCustomer
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      ) : null}
      {create ? (
        <EditCreateCustomer
          state={'create'}
          open={create}
          setOpen={setCreate}
          record={null}
        />
      ) : null}
      <div className='flex mb-4'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <button
          className='btn btn-outline-theme ml-auto mb-4'
          onClick={() => setCreate(true)}
        >
          Create Customer
        </button>
      </div>
      <br />
      {customers ? (
        <ReusableTable
          columns={columns}
          data={customers?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: customers?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      ) : null}
    </div>
  )
}

export default Customers
